import { render, staticRenderFns } from "./PromotionOriginIcon.vue?vue&type=template&id=62723d20&"
import script from "./PromotionOriginIcon.vue?vue&type=script&lang=ts&"
export * from "./PromotionOriginIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports